<template>
  <div data-cy="login">
    <div class="col s12 green pd10" v-if="verified">
      {{ $t('views.profile.emailVerified') }}
    </div>

    <div class="mt10" v-if="!groupLoading">
      <component
        v-if="group"
        :is="formComponent"
        :group="group"
        :redirect="redirectPath"
        :show-username="showUsername"
      ></component>
      <div v-else>
        <login-form
          :organization-id="group ? group.OrganizationId : '0'"
          :group-id="group ? group.Id : '0'"
          :redirect="redirectPath"
          :show-username="showUsername"
          class="mt20"
        ></login-form>
      </div>
    </div>
    <div style="text-align: center" v-else>
      <loader-vue color="black">Laddar..</loader-vue>
    </div>
  </div>
</template>

<script>
import LoginForm from '@common/Components/Auth/Login';
import GroupService from '@common/Services/Groups/GroupService.js';
import LoaderVue from '@common/Components/Loader.vue';
import RecovacFormVue from './form-specific/RecovacForm.vue';
import OdemFormVue from './form-specific/OdemForm.vue';
import DefaultFormVue from './form-specific/DefaultForm.vue';
import DiatestFormVue from './form-specific/DiatestForm.vue';

export default {
  name: 'LoginView',
  components: {
    LoginForm,
    LoaderVue,
    DiatestFormVue,
    RecovacFormVue,
    OdemFormVue,
    DefaultFormVue
  },
  props: {
    groupUrlSlug: {
      type: String
    }
  },
  data() {
    return {
      group: null,
      formComponent: '',
      personnummer: null,
      registered: false,
      groupLoading: false
    };
  },
  mounted() {
    const body = document.querySelector('body');
    body.classList.remove('logged-in');
    body.classList.add('not-logged-in');

    let groupUrlSlug = this.groupUrlSlug || this.$route.query.groupUrlSlug;

    if (!groupUrlSlug && this.$route.query.redirect) {
      const [_url, urlSlug] =
        this.$route.query.redirect.match(/group\/(.*)\/prom/) || [];

      if (urlSlug) {
        groupUrlSlug = urlSlug;
      }
    }

    if (groupUrlSlug) {
      this.getGroupByUrlSlug(groupUrlSlug).then(() => {
        this.setFormComponent(groupUrlSlug);
      });
    }
  },
  computed: {
    verified() {
      return (
        this.$route.query.hasOwnProperty('verifiedemail') &&
        this.$route.query.verifiedemail === 1
      );
    },
    redirectPath() {
      let redirectPath = '/welcome';

      if (this.group && this.group.Id) {
        if (this.group.InitialPromId) {
          redirectPath = `/group/${this.group.UrlSlug}/prom`;
        } else if (this.group.InitialUri) {
          redirectPath = this.group.InitialUri;
        }
      }

      return redirectPath;
    },
    showUsername() {
      return process.env.NODE_ENV !== 'production';
    }
  },
  methods: {
    getGroupByUrlSlug(urlSlug) {
      this.groupLoading = true;
      return GroupService.getGroupByUrlSlug(urlSlug)
        .then(group => (this.group = group))
        .finally(() => (this.groupLoading = false));
    },
    setFormComponent(groupUrlSlug) {
      switch (groupUrlSlug.toLowerCase()) {
        case 'recovac':
          this.formComponent = `RecovacFormVue`;
          break;
        case 'odem':
          this.formComponent = `OdemFormVue`;
          break;
        case 'diatest':
        case 'diatest-pilot':
          this.formComponent = `DiatestFormVue`;
          break;
        default:
          this.formComponent = `DefaultFormVue`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.register {
  text-align: center;
  margin-top: 30px;
  position: relative;
}
</style>
